import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Library, ClipboardCheck, FileSignature, Scale } from 'lucide-react';
const bonuses = [{
  icon: <Library className="w-7 h-7" data-id="element-30" />,
  n: 'Bono #1',
  title: 'Biblioteca Premium de Modelos Jurídicos Editables',
  desc: 'Una colección de modelos profesionales organizados por temática para adaptar rápidamente a cada caso y ahorrar horas de trabajo.'
}, {
  icon: <ClipboardCheck className="w-7 h-7" data-id="element-31" />,
  n: 'Bono #2',
  title: 'Kit Profesional para Estudios Jurídicos',
  desc: 'Formularios, checklists, planillas y herramientas listas para organizar expedientes, gestionar clientes y optimizar el trabajo diario del estudio.'
}, {
  icon: <Scale className="w-7 h-7" data-id="element-32" />,
  n: 'Bono #3',
  title: 'Biblioteca de Jurisprudencia y Argumentación Jurídica',
  desc: 'Fallos relevantes, criterios judiciales y fundamentos organizados para respaldar cada reclamo con mayor seguridad profesional.'
}, {
  icon: <FileSignature className="w-7 h-7" data-id="element-33" />,
  n: 'Bono #4',
  title: 'Sistema Profesional de Estrategias para Reclamos de Consumo',
  desc: 'Matrices de análisis, hojas de estrategia, cronogramas y recursos prácticos para evaluar cada caso y trabajar con mayor rapidez y mejores resultados.'
}];
export const Bonuses = () => {
  return <section className="py-12 bg-legal-900" data-id="element-34">
      <div className="container mx-auto px-4" data-id="element-35">
        <div className="text-center mb-10 max-w-2xl mx-auto" data-id="element-36">
          <span className="inline-flex items-center gap-2 text-gold-500 font-semibold tracking-widest uppercase text-sm mb-4" data-id="element-37">
            <Gift className="w-4 h-4" data-id="element-38" />
            Bonos GRATIS incluidos
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-39">
            🎁 Bonos GRATIS incluidos
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-40">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="relative bg-legal-800 border border-gold-500/30 rounded-xl p-7 flex flex-col hover:border-gold-500/60 transition-colors" data-id="element-41">
              <span className="absolute -top-3 left-6 bg-gold-500 text-legal-900 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-42">
                {bonus.n}
              </span>

              <div className="mb-5 mt-2 flex items-center justify-center w-14 h-14 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-43">
                {bonus.icon}
              </div>

              <h3 className="text-lg font-bold text-white mb-3 leading-snug" data-id="element-44">
                {bonus.title}
              </h3>

              <p className="text-sm text-slate-300 leading-relaxed flex-1" data-id="element-45">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};